import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=c6ff1fa0&"
import script from "./CustomIcon.vue?vue&type=script&lang=js&"
export * from "./CustomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports